module.exports = __webpack_public_path__ + "static/media/photo46.4650917e.jpg";